module.exports = "/integrations/parametersModal/template-f5ca39.html";